var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0392 20.0526C5.88049 20.0526 1.69856 15.9436 1.69856 10.8669C1.69856 5.7902 5.88049 1.67306 11.0392 1.67306C16.1979 1.67306 20.3807 5.7902 20.3807 10.8669C20.3807 15.9436 16.1979 20.0526 11.0392 20.0526ZM25.9888 24.8094L19.2152 18.1416C20.9892 16.2143 22.0783 13.6718 22.0783 10.8669C22.0783 4.86347 17.1361 0 11.0392 0C4.9422 0 0 4.86347 0 10.8669C0 16.8622 4.9422 21.7257 11.0392 21.7257C13.6735 21.7257 16.0896 20.8153 17.9875 19.298L24.7889 25.9904C25.1203 26.3185 25.6575 26.3185 25.9888 25.9904C26.321 25.6706 26.321 25.1375 25.9888 24.8094ZM15.3277 10.178H7.0885C6.6448 10.178 6.28475 10.5306 6.28475 10.9653C6.28475 11.4 6.6448 11.7527 7.0885 11.7527H15.3277C15.7714 11.7527 16.1314 11.4 16.1314 10.9653C16.1314 10.5306 15.7714 10.178 15.3277 10.178Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoomOutIcon.e3db1ac319c132c8b3dbdefe7a2a9d97.svg";
export { ForwardRef as ReactComponent };